// extracted by mini-css-extract-plugin
export var button = "_ig-0";
export var donut = "_ig-1";
export var donutFill = "_ig-3";
export var donutTrack = "_ig-2";